import { connect } from 'react-redux'
import { DiscountsComponent } from './DiscountsComponent'
import { Dispatch } from 'redux'
import {
    fetchPrivilegesPageData,
    kingdomCouponsSelector
} from 'shared/store/kingdom/privileges'
import { fetchPointsPageData } from 'shared/store/kingdom/points'
import type { CacPromotion, Coupon } from 'shared/types'
import type { ItemInfos } from 'shared/store/ecommerce/order'
import {
    processCouponNavigation,
    setCurrentItemInfos
} from 'shared/store/ecommerce/order'
import type { RootState } from 'shared/store/reducers'
import { push } from 'connected-react-router'
import type { EventMetadata } from 'shared/store/metadata'
import { eventMetadata } from 'shared/store/metadata'
import { getProductById } from 'shared/store/ecommerce/catalog'
import { getFilteredCoupons } from 'shared/utils/ecommerce/utils'

const mapStateToProps = (state: RootState) => {
    const { dataLoaded: dataLoaded1 } = state.kingdomPrivilegesPageState

    const { dataLoaded: dataLoaded2 } = state.kingdomPointsPageState

    const {
        collectMode,
        restaurant,
        idsCouponsTemporaryBurned
    } = state.ecommerceOrderState

    const { promotionsById } = state.ecommerceCatalogState

    const { available } = state.featuresState

    const kingdomCoupons = kingdomCouponsSelector(state)

    const filteredCoupons = getFilteredCoupons(
        kingdomCoupons,
        restaurant,
        collectMode,
        idsCouponsTemporaryBurned
    )
    const couponsValidLength = filteredCoupons.length

    const getProduct = (id: string) =>
        getProductById(state.ecommerceCatalogState, id)

    return {
        featuresAvailable: available,
        coupons: filteredCoupons,
        nbCoupons: couponsValidLength,
        kingdomDataLoaded: dataLoaded1 && dataLoaded2,
        promotionsById,
        getProduct
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    fetchPrivilegesData: () => d(fetchPrivilegesPageData()),
    fetchPointsData: () => d(fetchPointsPageData()),
    setCurrentItemInfos: (itemInfos: ItemInfos) =>
        d(setCurrentItemInfos(itemInfos)),
    processCouponNavigation: (coupon: Coupon, promotion: CacPromotion) =>
        d(processCouponNavigation(coupon, promotion)),
    sendMeta: (meta: EventMetadata) => d(eventMetadata(meta)),
    navigate: (to: string, state?: any) =>
        d(
            push({
                pathname: to,
                state
            })
        )
})

const Discounts = connect(
    mapStateToProps,
    mapDispatchToProps
)(DiscountsComponent)

export { Discounts }
